<template>
<div class="flat-view">
    <amf-form title="User Management" class="container">
        <div class="container">
            <div class="row">
                <amf-input label="User Name" v-model="username" />
                <amf-input label="Email" v-model="email" />
                <amf-input label="Full Name" v-model="fullName" />
                <amf-select label='Roles' v-model="role" caption="--Select Role--" :options="userRoles" />
                <amf-select label='Status' v-model="status" :options="statusOptions" />
            </div>
            <div class="row">
                <div class="col-12" style="text-align: right;">
                    <div style="margin-bottom: 1rem;">
                        <amf-button :onClick="search" class="btn-success">Search</amf-button>
                        <amf-button :onClick="clear" class="ml-2">Clear</amf-button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12" v-if="!usersReady && !promptToSearch">
                    Loading...
                </div>
                <div class="col-12" v-else>
                    <div v-if="users.length == 0 && !promptToSearch">No matching users</div>
                    <div v-if="users.length == 0 && promptToSearch">Please enter search criteria</div>
                    <table class="table table-sm table-condensed table-hover" v-if="users.length != 0">
                        <thead>
                            <th>User Name</th>
                            <th>Full Name</th>
                            <th>Roles</th>
                            <th width="5%"></th>
                        </thead>
                        <tbody>
                            <tr v-for="user in users" :key="user.userId">
                                <td @click="showUser(user.userId)" width="30%">
                                    <span v-if="!user.isApproved" class="fa fa-ban text-danger"></span>
                                    <span v-if="user.isLockedOut" class="fa fa-lock fa-lg text-danger"></span>
                                    <span>{{user.userName}}</span>
                                    <span v-if="user.userName != user.email"> (Email: {{user.email}})</span>
                                </td>
                                <td @click="showUser(user.userId)">{{user.firstName + (user.firstName ? "&nbsp;" : "") + user.lastName}}</td>
                                <td @click="showUser(user.userId)">{{getRoles(user.roles)}}</td>
                                <td>
                                    <button class="btn-sm btn-primary" @click.prevent="unlockUser(user)"
                                        v-if="user.isApproved && user.isLockedOut">
                                        Unlock
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </amf-form>
</div>
</template>

<script>
import UserDetail from "./UserDetail.vue";
import { userRoles } from './user-labels.js';

export default {
    data() {
        return {
            username: null,
            email: null,
            fullName: null,
            role: null,
            userRoles: userRoles,
            promptToSearch: true,
            status: "all",
            statusOptions: [
                { id: "active", name: "Active Users Only" },
                { id: "inactive", name: "Inactive Users Only" },
                { id: "locked", name: "Locked Out Only" },
                { id: "all", name: "All Users" },
            ],
            amfOptions: { noTracking: true }
        }
    },
    created() {
        this.clear();
    },
    methods: {
        create() {
            this.showUser();
        },
        getRoles(roles) {
            let str = "";
            if(roles.length > 0 ) str = str + this.getUserLabelName(roles[0]);
            if(roles.length > 1 ) str = str + '...';
            return str;
        },
        getUserLabelName(id) {
            let label = userRoles.find(x => x.id == id)
            return label ? label.name : "";
        },
        async showUser(userId) {
            await this.$store.dispatch('user/load', { userId });
            var data = modalService
                .show("user-detail", UserDetail, {}).then(() => { return false; });
        },
        async search() {
            let data = {
                username: this.username,
                email: this.email,
                fullName: this.fullName,
                role: this.role,
                status: this.status
            };
            this.busy = true;
            this.promptToSearch = false;
            await this.$store.dispatch('users/search', data);
            this.busy = false;
        },
        async clear() {
            this.username = null;
            this.email = null;
            this.fullName = null;
            this.role = null;
            this.status = "all";
            this.promptToSearch = true;

            await this.$store.dispatch('users/clear', {});
        },
        async unlockUser(user) {
            if (await modalService.confirm("Are you sure you want to unlock the user?")) {
                await this.$store.dispatch('users/unlock', { userId: user.userId });
            }
        },
    },
    computed: {
        ...amfx.map("users", ["users", "usersReady:ready"]),
        headerButtons() {
            if (this.can.createUser) return ["Create.plus"];
        },
    },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/user/ManageUsers.vue